// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.seon-email[data-v-de32c8ea] {\n  width: 90vw;\n  max-height: 85vh;\n  max-width: 50rem;\n}\nh5[data-v-de32c8ea] {\n  font-family: inherit;\n  font-weight: 500;\n  margin-bottom: 1rem;\n}\n", ""]);
// Exports
module.exports = exports;
